import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { MethodSection } from '../components/MethodSection';
import { AudienceSection } from '../components/AudienceSection';
import { OfferSection } from '../components/OfferSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden selection:bg-terracotta/20 selection:text-terracotta" data-id="element-137">
      <HeroSection data-id="element-138" />
      <PainSection data-id="element-139" />
      <MethodSection data-id="element-140" />
      <AudienceSection data-id="element-141" />
      <OfferSection data-id="element-142" />

      <footer className="w-full py-12 text-center text-charcoal/40 text-sm border-t border-stone/50 bg-white/50" data-id="element-143">
        <p data-id="element-144">
          © {new Date().getFullYear()} Duelo Libre 40+. Todos los derechos
          reservados.
        </p>
        <div className="mt-4 space-x-4" data-id="element-145">
          <a href="#" className="hover:text-charcoal/60 underline" data-id="element-146">
            Términos
          </a>
          <a href="#" className="hover:text-charcoal/60 underline" data-id="element-147">
            Privacidad
          </a>
          <a href="#" className="hover:text-charcoal/60 underline" data-id="element-148">
            Contacto
          </a>
        </div>
      </footer>
    </main>;
}